export default {
  labels: {
    open: 'Näytä tuotteet',
    collapse: 'Piilota tuotteet',
    in_stock: 'Varastossa',
    out_of_stock: 'Loppu varastosta',
    visible: 'Näkyy valikossa',
    hidden: 'Piilotettu valikosta',
  },
  list: {
    name: 'Tuote',
    price: 'Hinta',
    is_available: 'SAATAVILLA/LOPPU',
  },
};
